<template>
  <div class="p-4 mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-ban text-danger"
            icon-size="17px"
            title="Decomisar"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="reasons"
              label="Razón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una razón"
              :error="errors[0]"
              v-model="model.reason"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario de Justificación:"
              v-model="model.comment"
              :error="errors[0]"
              :custom-error-msg="'Este campo es requerido'"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import CustomDropDown from "custom-drop-down";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomCallout from "custom-callout";
import CustomResultNotFound from "custom-result-not-found";
import { name as appModuleName } from "@/modules/app/store/index";
import { mapGetters } from "vuex";

import reasonTypes from "@/utils/constants/inventory/reasonTypes";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";

const DEFAULT_REASON_ID = 34;

export default {
  name: "ConfiscateEquipment",
  components: {
    ActionButton,
    CustomDropDown,
    IconView,
    CustomTextArea,
    CustomCallout,
    CustomResultNotFound
  },
  mixins: [alertMixin],
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      reasons: [],
      model: {
        comment: "",
        reason: null
      }
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: "getIsMobileDensity"
    })
  },
  async mounted() {
    Promise.all([this.getReasons()]);
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!isConfirmed) {
        return;
      }

      const payload = {
        bookId: this.book.id,
        reasonId: this.model.reason.id,
        comment: this.model.comment
      };

      this.$emit("save", payload);
    },
    async getReasons() {
      const { data } = await inventoryCatalogService.getReasonsByType(
        reasonTypes.BookSeize
      );
      this.reasons = data;
    }
  }
};
</script>
<style lang="scss"></style>
